import React from 'react';
import { Card } from 'primereact/card';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Tag } from 'primereact/tag';
import { Button } from 'primereact/button';

const RecentTransactions = ({ data }) => {
    const getSeverity = (type) => {
        return type === 'Payment' ? 'success' : 'info';
    };

    const actionBodyTemplate = (rowData) => {
        return (
            <Button 
                icon="pi pi-eye" 
                className="p-button-rounded p-button-text" 
                onClick={() => console.log('View transaction', rowData.transactionId)}
            />
        );
    };

    const amountTemplate = (rowData) => {
        const amount = rowData.debit > 0 ? rowData.debit : rowData.credit;
        const isDebit = rowData.debit > 0;
        return (
            <span className={isDebit ? 'positive-amount' : 'negative-amount'}>
                {isDebit ? '-' : '+'} ₹{amount.toLocaleString()}
            </span>
        );
    };

    return (
        <Card className="recent-transactions">
            <div className="table-header">
                <h3>Recent Transactions</h3>
                <Button 
                    label="View All" 
                    icon="pi pi-arrow-right" 
                    iconPos="right"
                    className="p-button-text"
                />
            </div>
            <DataTable value={data} className="p-datatable-sm" responsiveLayout="scroll">
                <Column field="loanAccountNo" header="Loan Account" style={{ minWidth: '120px' }} />
                <Column field="memberName" header="Member" style={{ minWidth: '130px' }} />
                <Column field="transactionDate" header="Date" 
                    body={(rowData) => new Date(rowData.transactionDate).toLocaleDateString()} 
                    style={{ minWidth: '100px' }}
                />
                <Column field="amount" header="Amount" body={amountTemplate} style={{ minWidth: '120px' }} />
                <Column field="transactionType" header="Type" 
                    body={(rowData) => (
                        <Tag 
                            value={rowData.transactionType} 
                            severity={getSeverity(rowData.transactionType)} 
                        />
                    )} 
                    style={{ minWidth: '100px' }}
                />
                <Column field="remarks" header="Remarks" style={{ minWidth: '150px' }} />
                <Column body={actionBodyTemplate} style={{ minWidth: '70px' }} />
            </DataTable>
        </Card>
    );
};

export default RecentTransactions;
